import {AppLink, NavigationMenu} from '@shopify/app-bridge/actions';
interface Shop {
    allow_shop_mini: number;
    legacy: number;
    free: number;
}
export default new class Menu {
    loadMenu(shop: Shop): void {
        const settingsLink = AppLink.create(window.app, {
            label: "Installation",
            destination: "/app/install",
        });


        const designLink = AppLink.create(window.app, {
            label: "Settings",
            destination: "/app/settings",
        });

        const links = [/**dashBoardLink,**/ settingsLink, designLink];

        if (shop.allow_shop_mini && shop.allow_shop_mini == 1) {
            const shopAppLink = AppLink.create(window.app, {
                label: "Shop App",
                destination: "/app/shop",
            });
            links.push(shopAppLink);
        }

        const dataLink = AppLink.create(window.app, {
            label: "Sync Data",
            destination: "/app/data",
        });
        links.push(dataLink);

        if (shop.legacy == 0) {
            const helpLink = AppLink.create(window.app, {
                label: "Help",
                destination: "/app/help",
            });
            links.push(helpLink);
        }


        if (shop.legacy == 0 && shop.free == 1) {
            const upgradeLink = AppLink.create(window.app, {
                label: "Upgrade",
                destination: "/app/wizard/2?upgrade=1",
            });
            links.push(upgradeLink);
        }

        const nav = NavigationMenu.create(window.app, {
            items: links,
        });
    }

};
